export const EXABORGANIZATIONLEAD_CREATE_RESET = 'EXABORGANIZATIONLEAD_CREATE_RESET'
export const EXABORGANIZATIONLEAD_CREATE_SET_CREATED = 'EXABORGANIZATIONLEAD_CREATE_SET_CREATED'
export const EXABORGANIZATIONLEAD_CREATE_SET_ERROR = 'EXABORGANIZATIONLEAD_CREATE_SET_ERROR'
export const EXABORGANIZATIONLEAD_CREATE_SET_VIOLATIONS = 'EXABORGANIZATIONLEAD_CREATE_SET_VIOLATIONS'
export const EXABORGANIZATIONLEAD_CREATE_TOGGLE_LOADING = 'EXABORGANIZATIONLEAD_CREATE_TOGGLE_LOADING'
